import { IScheduledTimingRepeat } from './ischeduled-timing-repeat';

export interface IEventTime {
    eventTimeIdentifier: string;
    display: string;
    tenantId: number;
    language: string;
    scheduledTimingRepeat: IScheduledTimingRepeat[];
}